import { injectable, inject } from 'inversify'
import type { CookieOptions, useCookie } from 'nuxt/app'

import DT from '../DependencyTypes'

@injectable()
export class CookieStorageService {
  constructor(@inject(DT.Cookies) readonly $cookies: typeof useCookie) {}

  public create<T>(
    key: string,
    options: CookieOptions<T> & { default: () => T },
  ): { get(): T, set(val: T): void } {
    const cookie = this.$cookies<T>(key, {
      ...(options as CookieOptions<T> & { readonly?: false }),
      path: options.path ?? '/',
    })

    return {
      get: () => cookie.value,
      set: (val: T) => {
        cookie.value = val
      },
    }
  }
}
